import { isEmpty } from '@utils/common';

import { IPortalGroupedTasksToLinkDTO, IPortalTaskToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';

export interface ITasksToLinkSelectOption {
	id: string;
	taskId?: string;
	title: string;
	startDate?: string;
	endDate?: string;
	isMilestone: boolean;
}

export const getTasksToLinkSelectOptions = (
	groupedTasks: IPortalGroupedTasksToLinkDTO[],
	selectedTasks: IPortalTaskToLinkDTO[],
): ITasksToLinkSelectOption[] => {
	const selectOptions: ITasksToLinkSelectOption[] = [];

	const selectedTaskIds = new Set(selectedTasks.map(task => task.taskId));

	for (let i = 0; i < groupedTasks.length; i++) {
		const milestone = groupedTasks[i];

		const filteredTasks = milestone.tasks.filter(task => !selectedTaskIds.has(task.taskId));

		if (!isEmpty(filteredTasks)) {
			selectOptions.push({
				id: milestone.id,
				startDate: milestone.startDate,
				endDate: milestone.endDate,
				title: milestone.title,
				isMilestone: true,
			});
		}

		for (let j = 0; j < filteredTasks?.length; j++) {
			const task = filteredTasks[j];

			selectOptions.push({
				id: task.id,
				taskId: task.taskId,
				startDate: task.startDate,
				endDate: task.endDate,
				title: task.title,
				isMilestone: false,
			});
		}
	}

	return selectOptions;
};
